export default __webpack_public_path__ + "static/media/message.8f12bc34.svg";